"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExploreWorkerController", {
    enumerable: true,
    get: function() {
        return ExploreWorkerController;
    }
});
let ExploreWorkerController = class ExploreWorkerController {
    init() {
        try {
            var _window_perf;
            console.log('WorkerController: Creating Web Worker');
            let workerUrl = window.WORKER_URL || '/dist/explore-multi-v2-sk/filter.worker.js';
            const version = (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.app_version;
            if (version && !workerUrl.startsWith('data:')) {
                const separator = workerUrl.includes('?') ? '&' : '?';
                workerUrl = `${workerUrl}${separator}v=${version}`;
            }
            const setupWorker = (w)=>{
                this.worker = w;
                this.worker.onmessage = (e)=>this.handleMessage(e);
                this.worker.onerror = (e)=>{
                    console.error('WorkerController: Worker error event:', e);
                    this.onError(`Worker error: ${e.message}`);
                };
            };
            if (workerUrl.startsWith('data:')) {
                setupWorker(new Worker(workerUrl));
                console.log('WorkerController: Worker created directly from Data URL');
            } else {
                console.log('WorkerController: Fetching worker code from:', workerUrl);
                fetch(workerUrl).then(async (resp)=>{
                    if (!resp.ok) throw new Error(`Failed to fetch worker: ${resp.statusText}`);
                    return await resp.text();
                }).then((code)=>{
                    const blob = new Blob([
                        code
                    ], {
                        type: 'application/javascript'
                    });
                    const blobUrl = URL.createObjectURL(blob);
                    setupWorker(new Worker(blobUrl));
                    console.log('WorkerController: Worker created via Blob URL');
                }).catch((e)=>{
                    console.error('WorkerController: Failed to fetch or create worker:', e);
                    this.onError(`Failed to fetch or create worker: ${e.message}`);
                });
            }
        } catch (e) {
            console.error('WorkerController: Failed to initialize worker:', e);
            this.onError(`Failed to initialize worker: ${e.message}`);
        }
    }
    handleMessage(e) {
        const { type, payload } = e.data;
        if (type === 'LOADED') {
            console.log('WorkerController: Worker loaded, sending INIT config');
            this.onLoaded();
            const origin = window.location.origin;
            // Send config to worker
            const config = {
                metaUrl: `${origin}/_/wasm/meta.json`,
                paramsUrlTemplate: `${origin}/_/wasm/params.json?v={version}`,
                wasmUrlTemplate: `${origin}/dist/explore-multi-v2-sk/filter.wasm?v={version}`,
                tracesUrlTemplate: `${origin}/_/wasm/traces.bin?v={version}`
            };
            this.worker.postMessage({
                type: 'INIT',
                payload: config
            });
        } else if (type === 'STATUS') {
            this.onStatus(payload.message);
        } else if (type === 'PROGRESS') {
            this.onProgress(payload);
        } else if (type === 'READY') {
            console.log('WorkerController: Worker Ready');
            this.ready = true;
            this.onReady();
        } else if (type === 'ERROR') {
            this.onError(payload.message);
        } else if (type === 'PARAMS_READY') {
            this.onParamsReady(payload);
        } else if (type === 'RESULT') {
            this.onResult(payload);
        } else if (type === 'SUGGEST_RESULT') {
            const { idx, requestId } = e.data;
            this.onSuggestResult(payload, idx, requestId);
        }
    }
    filter(queries, numUserQueries, requestId) {
        if (!this.worker || !this.ready) {
            console.warn('WorkerController: Worker not ready for filtering');
            return -1;
        }
        const finalRequestId = requestId !== null && requestId !== void 0 ? requestId : ++this.workerRequestId;
        this.workerRequestId = Math.max(this.workerRequestId, finalRequestId);
        this.worker.postMessage({
            type: 'FILTER',
            queries: queries,
            numUserQueries: numUserQueries,
            requestId: finalRequestId
        });
        return finalRequestId;
    }
    suggest(query, currentQuery, idx, availableParams, includeParams) {
        if (!this.worker || !this.ready) {
            console.warn('WorkerController: Worker not ready for suggestions');
            return 0;
        }
        this.workerRequestId++;
        this.worker.postMessage({
            type: 'SUGGEST',
            query: query,
            currentQuery: currentQuery,
            requestId: this.workerRequestId,
            idx: idx,
            availableParams: availableParams,
            includeParams: includeParams
        });
        return this.workerRequestId;
    }
    getRandomTrace(callback) {
        if (!this.worker || !this.ready) {
            callback(null);
            return;
        }
        const handler = (e)=>{
            if (e.data.type === 'RANDOM_TRACE_RESULT') {
                this.worker.removeEventListener('message', handler);
                callback(e.data.payload);
            }
        };
        this.worker.addEventListener('message', handler);
        this.worker.postMessage({
            type: 'GET_RANDOM_TRACE'
        });
    }
    isReady() {
        return this.ready;
    }
    terminate() {
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
            this.ready = false;
        }
    }
    constructor(onLoaded, onReady, onProgress, onError, onParamsReady, onResult, onSuggestResult, onStatus){
        this.onLoaded = onLoaded;
        this.onReady = onReady;
        this.onProgress = onProgress;
        this.onError = onError;
        this.onParamsReady = onParamsReady;
        this.onResult = onResult;
        this.onSuggestResult = onSuggestResult;
        this.onStatus = onStatus;
        this.worker = null;
        this.ready = false;
        this.workerRequestId = 0;
    }
};
